module.exports = __webpack_public_path__ + "assets/events_coup_primary.d9fcb9ab.svg";